import { ReactElement } from 'react';
import { IFragmentFreshpaintVideo } from 'types/contentful';
import { FRESHPAINT_VIDEO_URL } from 'lib/consts';
import { VideoTypeId, VideoTypes } from 'components/Contentful/VideoPlayer';

export const isFreshpaintVideoGuard = (
  videoObject: VideoTypes
): videoObject is IFragmentFreshpaintVideo => {
  return (
    (videoObject as IFragmentFreshpaintVideo).sys.contentType.sys.id === VideoTypeId.Freshpaint
  );
};

type Props = {
  video: IFragmentFreshpaintVideo;
  isAutoPlay?: boolean;
  isMuted?: boolean;
  isLooped?: boolean;
  showControls?: boolean;
  classNames?: string;
};

export default function FreshpaintVideo({
  video,
  isAutoPlay = false,
  isMuted = false,
  isLooped = true,
  showControls = true,
  classNames = '',
}: Props): ReactElement {
  return (
    <iframe
      className={classNames}
      src={`${FRESHPAINT_VIDEO_URL}/${video.fields.videoId}?autoplay=${
        isAutoPlay ? '1' : '0'
      }&muted=${isMuted ? '1' : '0'}&loop=${isLooped ? '1' : '0'}&controls=${
        showControls ? '1' : '0'
      }`}
      frameBorder="0"
      aria-label="Freshpaint Embed Player"
      title="Freshpaint Video Player"
      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  );
}
